/**
 * Logger Utility
 * ใช้สำหรับ logging ที่สามารถ control ได้ตาม environment
 * ใน production mode จะไม่ print log ออกมา เพื่อ performance
 */

const isDevelopment = process.env.NODE_ENV === 'development'

// สามารถเปิด/ปิด debug logs แยกตาม feature ได้
const DEBUG_FLAGS = {
  dynamicHeaders: true, // logs เกี่ยวกับ dynamic headers
  bookingData: true, // logs เกี่ยวกับ booking data
  api: true, // logs เกี่ยวกับ API calls
  general: true // logs ทั่วไป
}

const logger = {
  /**
   * Log ข้อมูลทั่วไป
   * @param {string} feature - ชื่อ feature (เช่น 'dynamicHeaders', 'bookingData')
   * @param {any} args - ข้อมูลที่ต้องการ log
   */
  log (feature, ...args) {
    if (isDevelopment && DEBUG_FLAGS[feature]) {
      console.log(`[${feature}]`, ...args)
    }
  },

  /**
   * Log warning
   */
  warn (feature, ...args) {
    if (isDevelopment && DEBUG_FLAGS[feature]) {
      console.warn(`[${feature}]`, ...args)
    }
  },

  /**
   * Log error - จะแสดงทั้ง dev และ production
   */
  error (feature, ...args) {
    console.error(`[${feature}]`, ...args)
  },

  /**
   * Log สำหรับ debug ข้อมูล (แสดงเฉพาะตอน development)
   */
  debug (feature, ...args) {
    if (isDevelopment && DEBUG_FLAGS[feature]) {
      console.log(`[DEBUG:${feature}]`, ...args)
    }
  },

  /**
   * เปิด/ปิด debug flag สำหรับ feature ใดๆ
   */
  setDebugFlag (feature, enabled) {
    DEBUG_FLAGS[feature] = enabled
  }
}

export default logger



// WEBPACK FOOTER //
// ./src/utils/logger.js